<template>
	<div>
		<BaseAccordionController
			:accordion_header="getStateWithParam('dormitorymodule_label')"
			><template v-slot:component>
				<v-container
					v-if="reservationAllowed"
					class="card-wrapper"
					grid-list-lg
				>
					<div class="form-area" v-if="!ConfirmedDialog">
						<v-form ref="form" v-model="valid" class="form-color">
							<v-container>
								<v-text-field
									v-model="formDate"
									disabled
									:label="
										getStateWithParam('dormitory_form_date')
									"
									outlined
								></v-text-field>

								<v-text-field
									v-model="formdata.personal_no"
									:label="
										getStateWithParam(
											'dormitory_form_id_card'
										)
									"
									outlined
									placeholder="J12345678U"
									:rules="cardIdRules"
									validate-on-blur
								></v-text-field>

								<v-text-field
									v-model="formdata.name"
									:label="
										getStateWithParam(
											'dormitory_form_first_name'
										)
									"
									outlined
									:rules="nameRules"
									validate-on-blur
								></v-text-field>

								<v-text-field
									v-model="formdata.paternity"
									:label="
										getStateWithParam(
											'dormitory_form_father_name'
										)
									"
									outlined
									:rules="fatherRules"
									validate-on-blur
								></v-text-field>

								<v-text-field
									v-model="formdata.surname"
									:label="
										getStateWithParam(
											'dormitory_form_last_name'
										)
									"
									outlined
									:rules="surnameRules"
									validate-on-blur
								></v-text-field>

								<v-text-field
									v-model="formdata.email"
									:label="
										getStateWithParam(
											'dormitory_form_email'
										)
									"
									outlined
									:rules="emailRules"
									validate-on-blur
								></v-text-field>
								<v-text-field
									v-model="formdata.tel"
									type="number"
									:label="
										getStateWithParam(
											'dormitory_form_phone_number'
										)
									"
									outlined
									:rules="numberRules"
									validate-on-blur
								></v-text-field>

								<v-select
									v-model="selectedGenderItems"
									:items="genderItems"
									:item-text="'name'"
									:item-value="'id'"
									:label="
										getStateWithParam(
											'dormitory_form_gender'
										)
									"
									required
									outlined="true"
									:rules="genderRules"
									validate-on-blur
								></v-select>

								<v-select
									v-model="selectedSchoolYear"
									:items="viti_shkollor"
									:item-text="'name'"
									:item-value="'id'"
									:label="
										getStateWithParam(
											'dormitory_form_school_year'
										)
									"
									required
									outlined="true"
									:rules="schoolYearRules"
									validate-on-blur
								></v-select>

								<v-text-field
									v-model="formdata.dega_e_studimit"
									:label="
										getStateWithParam(
											'dormitory_form_degree'
										)
									"
									outlined
									:rules="schoolDegreeRules"
									validate-on-blur
								></v-text-field>

								<v-select
									v-model="selectedCity"
									:items="district"
									:item-text="'name'"
									:item-value="'id'"
									:label="
										getStateWithParam('dormitory_form_city')
									"
									required
									outlined="true"
									:rules="cityRules"
									validate-on-blur
								></v-select>

								<v-select
									v-model="selectedWorkStatus"
									:items="statusi_punesimit"
									:item-text="'name'"
									:item-value="'id'"
									:label="
										getStateWithParam(
											'dormitory_form_work_status'
										)
									"
									required
									outlined="true"
									:rules="workRules"
									validate-on-blur
								></v-select>
								<v-select
									v-model="selectedBuilding"
									:no-data-text="
										getStateWithParam(
											'dormitory_form_nodata_building'
										)
									"
									:items="buildingItems"
									:item-text="'name'"
									:item-value="'id'"
									:label="
										getStateWithParam(
											'dormitory_form_building'
										)
									"
									required
									outlined="true"
									:rules="buildingRules"
									validate-on-blur
								></v-select>

								<v-select
									v-model="selectedRoom"
									:items="roomItems"
									:item-text="'name'"
									:item-value="'id'"
									:no-data-text="
										getStateWithParam(
											'dormitory_form_nodata_room'
										)
									"
									:label="
										getStateWithParam('dormitory_form_room')
									"
									required
									outlined="true"
									:rules="roomRules"
									validate-on-blur
								></v-select>

								<v-textarea
									outlined="true"
									:label="
										getStateWithParam(
											'dormitory_form_notes'
										)
									"
									v-model="formdata.notes"
									validate-on-blur
								></v-textarea>

								<div class="room-info mt-2" v-if="roomInfo">
									<p>
										<strong
											>{{
												getStateWithParam(
													"dormitory_form_room"
												)
											}}:</strong
										>
										{{ roomInfo.name }}
									</p>
									<p>
										<strong
											>{{
												getStateWithParam(
													"dormitory_form_capacity"
												)
											}}:</strong
										>
										{{ roomInfo.kapaciteti }}
									</p>
									<p>
										<strong
											>{{
												getStateWithParam(
													"dormitory_form_open_space"
												)
											}}:</strong
										>
										{{ roomInfo.vende_te_pa_rezervuara }}
									</p>
									<p>
										<strong
											>{{
												getStateWithParam(
													"dormitory_form_price"
												)
											}}:</strong
										>
										<br />
										-{{ roomInfo.info_cmimi_1 }},
										<br />
										-{{ roomInfo.info_cmimi_2 }},
										<br />
										-{{ roomInfo.info_cmimi_3 }}
									</p>
								</div>
								<strong class="mt-3">
									{{
										getStateWithParam(
											"dormitory_form_validation_message"
										)
									}}
								</strong>
							</v-container>
						</v-form>

						<div class="submit">
							<v-btn
								depressed
								class="submit-button align-center"
								@click.native="submitForm()"
							>
								{{ getStateWithParam("dormitory_form_button") }}
							</v-btn>
						</div>
						<v-dialog
							v-if="bookingSent === true"
							v-model="notConfirmedDialog"
							@close="notConfirmedDialog === false"
						>
							<v-card>
								<v-card-title class="text-h5 grey lighten-2">
									{{
										getStateWithParam(
											"dormitory_not_confirmed_title"
										)
									}}
								</v-card-title>

								<v-card-text
									class="error-message-from-server-here"
								>
									{{ errorMessage }}
								</v-card-text>

								<v-card-actions>
									<v-spacer></v-spacer>
									<v-btn
										class="back-button"
										color="primary"
										text
										@click="notConfirmedDialog = false"
									>
										{{
											getStateWithParam(
												"dormitory_form_toast_back_button"
											)
										}}
									</v-btn>
								</v-card-actions>
							</v-card>
						</v-dialog>
					</div>

					<div
						class="succesful-reservation"
						v-if="bookingSent && ConfirmedDialog && successMessage"
					>
						<div class="v-html" v-html="successMessage"></div>
					</div>
				</v-container>
				<v-container v-else>
					<strong
						>{{ getStateWithParam("dormitorymodule_not_allowed") }}
					</strong>
					<br />
					{{ getStateWithParam("dormitorymodule_not_allowed_dates") }}
					<br />
					<strong>{{ data_ora_start }} </strong> -
					<strong>{{ data_ora_end }} </strong>
				</v-container>
			</template>
		</BaseAccordionController>
	</div>
</template>

<script>
import { mapGetters } from "vuex";
import axios from "axios";
import {
	API_CLIENT_POST_FORM,
	API_CLIENT_GET,
} from "@/config/api/api_call/service_instances";
import {
	DORMITORY_ACCESS_URL,
	DORMITORY_FORM_DATA_URL,
	DORMITORY_BUILDING_URL,
	DORMITORY_ROOM_URL,
	DORMITORY_POST_URL,
} from "../../config/api/url/urls_in_app.js";
export default {
	name: "dormitoryForm",
	components: {},
	props: {},
	data() {
		return {
			reservationAllowed: false,
			//reservationMessage: "",
			data_ora_start: "",
			data_ora_end: "",

			id_skedulim_rezervim: null,
			selectedGenderItems: "",
			selectedSchoolYear: "",
			selectedCity: "",
			selectedWorkStatus: "",
			selectedBuilding: "",
			selectedRoom: "",

			//to be changed -
			// genderItems: [
			// 	{
			// 		name: "Male",
			// 		id: "M",
			// 	},
			// 	{ name: "Female", id: "F" },
			// ],
			viti_shkollor: [],
			district: [],
			statusi_punesimit: [],
			buildingItems: [],
			roomItems: [],
			roomInfo: null,

			formdata: {
				personal_no: "",
				name: "",
				paternity: "",
				surname: "",
				email: "",
				tel: "",
				dega_e_studimit: "",
				price: "",
				notes: "",
			},

			xFormToken: null,

			dataloaded: false,

			bookingSent: false,
			notConfirmedDialog: false,
			ConfirmedDialog: false,
			successMessage: "",
			errorMessage: "",

			valid: true,

			cardIdRules: [
				(v) =>
					!!v ||
					this.getStateWithParam("dormitory_form_card_id_rule"),
				(v) =>
					(v.length >= 5 && v.length <= 20) ||
					this.getStateWithParam(
						"dormitory_form_card_id_rule_length"
					),
			],

			nameRules: [
				(v) =>
					!!v || this.getStateWithParam("dormitory_form_name_rule"),
				(v) =>
					(v.length >= 2 && v.length <= 20) ||
					this.getStateWithParam("dormitory_form_name_length_rule"),
			],

			fatherRules: [
				(v) =>
					!!v || this.getStateWithParam("dormitory_form_father_rule"),
				(v) =>
					(v.length >= 2 && v.length <= 20) ||
					this.getStateWithParam("dormitory_form_father_length_rule"),
			],

			surnameRules: [
				(v) =>
					!!v ||
					this.getStateWithParam("dormitory_form_surname_rule"),
				(v) =>
					(v.length >= 2 && v.length <= 20) ||
					this.getStateWithParam(
						"dormitory_form_surname_length_rule"
					),
			],

			emailRules: [
				(v) =>
					!!v ||
					this.getStateWithParam(
						"dormitory_form_email_required_rule"
					),
				(v) =>
					this.validateEmail(v) ||
					this.getStateWithParam("dormitory_form_email_valid_rule"),
			],

			numberRules: [
				(v) =>
					!!v || this.getStateWithParam("dormitory_form_number_rule"),
				(v) =>
					(v.length >= 5 && v.length <= 20) ||
					this.getStateWithParam("dormitory_form_number_length_rule"),
			],

			genderRules: [
				(v) =>
					!!v || this.getStateWithParam("dormitory_form_gender_rule"),
			],

			schoolYearRules: [
				(v) =>
					!!v ||
					this.getStateWithParam("dormitory_form_school_year_rule"),
			],

			schoolDegreeRules: [
				(v) =>
					!!v ||
					this.getStateWithParam("dormitory_form_school_degree_rule"),
				(v) =>
					(v.length >= 3 && v.length <= 100) ||
					this.getStateWithParam(
						"dormitory_form_school_degree_min_rule"
					),
			],

			cityRules: [
				(v) =>
					!!v || this.getStateWithParam("dormitory_form_city_rule"),
			],

			workRules: [
				(v) =>
					!!v || this.getStateWithParam("dormitory_form_work_rule"),
			],

			buildingRules: [
				(v) =>
					!!v ||
					this.getStateWithParam("dormitory_form_building_rule"),
			],

			roomRules: [
				(v) =>
					!!v || this.getStateWithParam("dormitory_form_room_rule"),
			],

			notesRules: [
				(v) =>
					v.length <= 250 ||
					this.getStateWithParam(
						"dormitory_form_school_notes_max_rule" //add
					),
			],
		};
	},
	created() {
		this.checkAccess();
	},
	computed: {
		formDate() {
			const today = new Date();
			const day = String(today.getDate()).padStart(2, "0");
			const month = String(today.getMonth() + 1).padStart(2, "0");
			const year = today.getFullYear();
			return `${day}/${month}/${year}`;
		},
		...mapGetters(["getLanguageParameters"]),

		genderItems() {
			// Get the selected language type from the store

			const selectedLanguageType = this.$store.state.type_language;

			if (selectedLanguageType == 1) {
				// Assuming 1 = Albanian
				return [
					{ name: "Mashkull", id: "M" },
					{ name: "Femer", id: "F" },
				];
			} else if (selectedLanguageType == 2) {
				// Assuming 2 = English
				return [
					{ name: "Male", id: "M" },
					{ name: "Female", id: "F" },
				];
			}

			return []; // Fallback, if needed
		},
	},

	watch: {
		selectedGenderItems(newGender) {
			if (newGender) {
				this.loadBuildings(newGender);
				this.selectedBuilding = null;
				this.selectedRoom = null;
			}
		},
		selectedBuilding(newBuilding) {
			if (newBuilding) {
				this.loadRooms(newBuilding);
				this.selectedRoom = null;
			}
		},
		selectedRoom(newRoom) {
			if (newRoom) {
				const filteredRoom = this.roomItems.find(
					(room) => room.id === newRoom
				);
				this.roomInfo = filteredRoom ? filteredRoom : null;
			} else {
				this.roomInfo = null;
			}
		},
	},

	methods: {
		goToHome() {
			this.$router.push({ name: "home" });
		},

		//check the email regex
		validateEmail(email) {
			return /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
				String(email).toLowerCase()
			);
		},

		checkAccess() {
			axios
				.get(DORMITORY_ACCESS_URL, {
					// headers: {
					// 	"x-subject-token": this.xSubjectToken,
					// },
				})
				.then((response) => {
					this.xFormToken = response.headers["x-form-token"];

					if (response.data.message.code === "0") {
						this.reservationAllowed = true;
						this.data_ora_start =
							response.data.data.items[0].data_ora_start;
						this.data_ora_end =
							response.data.data.items[0].data_ora_end;
						this.id_skedulim_rezervim =
							response.data.data.items[0].id;
						this.loadFormData();
					} else {
						this.reservationAllowed = false;
						console.error(
							"Access is not allowed:",
							response.data.message
						);

						this.$store.state.active_loader = false;
					}
				})
				.catch((err) => {
					console.error("Error checking access:", err);
				});
		},

		loadFormData() {
			axios
				.get(DORMITORY_FORM_DATA_URL, {
					headers: {
						// "x-subject-token": this.xSubjectToken, // to be deleted
						"x-form-token": this.xFormToken,
					},
				})
				.then((response) => {
					this.viti_shkollor =
						response.data.data.items.viti_shkollor.items;
					this.district = response.data.data.items.district.items;
					this.statusi_punesimit =
						response.data.data.items.statusi_punesimit.items;
				})
				.catch((err) => {
					console.error("Error loading form data:", err);
				})
				.finally(() => {
					this.$store.state.active_loader = false;
				});
		},

		loadBuildings(gender) {
			axios
				.get(DORMITORY_BUILDING_URL, {
					headers: {
						// "x-subject-token": this.xSubjectToken, // to be deleted
						"x-form-token": this.xFormToken,
					},
					params: { gender },
				})
				.then((response) => {
					this.buildingItems = response.data.data.items;
				})
				.catch((err) => {
					console.error("Error loading buildings:", err);
				});
		},

		loadRooms(id_godina) {
			axios
				.get(DORMITORY_ROOM_URL, {
					headers: {
						// "x-subject-token": this.xSubjectToken, // to be deleted
						"x-form-token": this.xFormToken,
					},
					params: { id_godina },
				})
				.then((response) => {
					this.roomItems = response.data.data.items;
				})
				.catch((err) => {
					console.error("Error loading rooms:", err);
				});
		},

		getStateWithParam(param) {
			return this.$store.getters.getLanguageParameters(param);
		},

		submitForm() {
			if (this.$refs.form.validate()) {
				const dataToSend = {
					id_skedulim_rezervim: this.id_skedulim_rezervim,
					id_dhoma: this.selectedRoom,
					name: this.formdata.name,
					paternity: this.formdata.paternity,
					surname: this.formdata.surname,
					gender: this.selectedGenderItems,
					tel: this.formdata.tel,
					email: this.formdata.email,
					personal_no: this.formdata.personal_no,
					id_viti_shkollor: this.selectedSchoolYear,
					id_district: this.selectedCity,
					id_statusi_punesimit: this.selectedWorkStatus,
					dega_e_studimit: this.formdata.dega_e_studimit,
					notes: this.formdata.notes,
				};
				this.$store.state.active_loader = false;
				axios
					.post(DORMITORY_POST_URL, dataToSend, {
						headers: {
							// "x-subject-token": this.xSubjectToken, // to be deleted
							"x-form-token": this.xFormToken,
							"Content-Type": "application/json",
						},
					})
					.then((response) => {
						this.bookingSent = true;
						this.ConfirmedDialog = true;
						this.successMessage = response.data.data.message;
						// setTimeout(() => {
						// 	this.goToHome();
						// }, 10000); // 10 seconds
					})
					.catch((err) => {
						this.bookingSent = true;
						this.notConfirmedDialog = true;
						this.selectedBuilding = null;
						this.selectedRoom = null;

						const errorCode = err.response.data.message.code;

						let errorMessage = "Ndodhi një error";
						if (errorCode) {
							errorMessage =
								this.getStateWithParam(`${errorCode}`) ||
								errorMessage;
						}

						this.errorMessage = errorMessage;

						console.error("Error submitting form:", err);
					})
					.finally(() => {
						this.$store.state.active_loader = false;
					});
			}
		},
	},
};
</script>

<style scoped>
.form-header {
	width: 100%;
	background-color: #e60000;
	color: #ffffff;
	font-size: 20px;
}

.submit {
	float: right;
	margin-top: 10px;
	margin-right: 6px;
}
.submit-button {
	background-color: #e60000 !important;
	color: #ffffff !important;
	margin-bottom: 25px !important;
}

.form-area {
	margin-top: -44px !important;
}

.back-button {
	margin-right: 16px;
	color: #ffffff !important;
}

.v-html {
	padding: 10px 10px 60px 10px;
}
</style>

<style>
#app
	> div.v-menu__content.theme--light.menuable__content__active
	> div.footer-btn-white.text-white {
	background-color: rgb(255, 255, 255) !important;
}

#app
	> div.v-dialog__content.v-dialog__content--active
	> div
	> div
	> div.v-card__actions
	> button
	> div {
	color: #ffffff;
}
</style>
